const HistoryGridComponent = {
    templateUrl: '/detailedHistory/historyGrid.tpl.html',
    controller: 'historyGridController',
    bindings: {
        parent: '<',
        gridModel: '<',
        widgetConfig: '<'
    }
};

angular.module('gw-um-submission')
    .component('uiHistoryGrid', HistoryGridComponent);
